"use strict";

var _typeof3 = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _bind = _interopRequireDefault(require("classnames/bind"));
var _keycode = _interopRequireDefault(require("keycode"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _useResizeObserver = _interopRequireDefault(require("../utils/useResizeObserver"));
var _Button = _interopRequireDefault(require("../Buttons/Button"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var _Title = _interopRequireDefault(require("../Title/Title"));
var _debounce = _interopRequireDefault(require("../utils/debounce"));
var _isFunction = _interopRequireDefault(require("../utils/isFunction"));
var _StyleConfig = require("../utils/StyleConfig");
var _useFocusManager = _interopRequireDefault(require("../utils/useFocusManager"));
var _useResponsiveSizes = _interopRequireDefault(require("../utils/useResponsiveSizes"));
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _withFocusWithin = _interopRequireDefault(require("../withFocusWithin"));
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _responsiveOverflowUtils = require("./_responsiveOverflowUtils");
var _ToolbarLayout = _interopRequireDefault(require("./_ToolbarLayout"));
var _ToolbarOverflow = _interopRequireDefault(require("./_ToolbarOverflow"));
var _ToolbarRegion = _interopRequireDefault(require("./_ToolbarRegion"));
var _ToolbarSeparator = _interopRequireDefault(require("./_ToolbarSeparator"));
var _ToolbarConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-concur_android.css") : void 0);
var _ToolbarConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-concur_default.css") : void 0);
var _ToolbarConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-concur_gateway.css") : void 0);
var _ToolbarConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-concur_ios.css") : void 0);
var _ToolbarSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-sap_fiori_3_dark.css") : void 0);
var _ToolbarSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-sap_fiori_3_hcb.css") : void 0);
var _ToolbarSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-sap_fiori_3_hcw.css") : void 0);
var _ToolbarSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-sap_fiori_3.css") : void 0);
var _ToolbarSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-sap_horizon_dark.css") : void 0);
var _ToolbarSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-sap_horizon_hcb.css") : void 0);
var _ToolbarSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-sap_horizon_hcw.css") : void 0);
var _ToolbarSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar-sap_horizon.css") : void 0);
var _excluded = ["autoOverflow", "children", "className", "classNameMap", "customTitle", "title", "titleProps", "toolbarStyle", "borderBottom", "borderTop", "focusProps", "isFocused", "breakpoints", "overflowButtonLabel", "itemsSize", "onSizeChange", "overflowContainerRef", "onOverflowToggle", "overflowButtonProps", "overflowItemsSize", "tableToolbar", "toolbarProps"],
  _excluded2 = ["ariaLabel", "iconName", "tooltipDelay", "tooltipProps", "iconProps"];
/* eslint-disable react/jsx-no-bind */
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty2(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  concur_android: _ToolbarConcur_android.default,
  concur_default: _ToolbarConcur_default.default,
  concur_gateway: _ToolbarConcur_gateway.default,
  concur_ios: _ToolbarConcur_ios.default,
  sap_fiori_3_dark: _ToolbarSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _ToolbarSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _ToolbarSap_fiori_3_hcw.default,
  sap_fiori_3: _ToolbarSap_fiori_.default,
  sap_horizon_dark: _ToolbarSap_horizon_dark.default,
  sap_horizon_hcb: _ToolbarSap_horizon_hcb.default,
  sap_horizon_hcw: _ToolbarSap_horizon_hcw.default,
  sap_horizon: _ToolbarSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-toolbar';
var DISPLAY_NAME = 'Toolbar';
var START_REGION_DISPLAY_NAME = "".concat(DISPLAY_NAME, ".Start");
var CENTER_REGION_DISPLAY_NAME = "".concat(DISPLAY_NAME, ".Center");
var END_REGION_DISPLAY_NAME = "".concat(DISPLAY_NAME, ".End");
var OVERFLOW_PADDING = 100;
var TOOLBAR_ITEMS = ['Button', 'SplitButton', 'Tooltip', 'IconButton', 'IconLink', 'ButtonDropdown', 'ToolbarSeparator', 'Link', 'ToggleSwitch', 'ComboBox', 'MenuButton', 'MultiComboBox', 'Checkbox', 'RadioGroup', 'Password', 'InputField', 'SegmentedButton', 'Select', 'StepInput', 'Switch', 'DatePicker', 'TimePicker'];
var getChildNodes = function getChildNodes(child) {
  var _context;
  if (typeof child.props.children === 'string') {
    return [child.props.children];
  }
  return (0, _map.default)(_context = _react.default.Children).call(_context, child.props.children, function (innerChild) {
    return /*#__PURE__*/_react.default.isValidElement(innerChild) && innerChild;
  });
};

/**
 * The **Toolbar** component acts as container for components.
 * It provides the styles, responsive behavior and keyboard interactions
 * needed to display components inline.
 *
 *  ## Responsive behavior
 * Consumers can define a **Toolbar**'s responsive behavior by wrapping toolbar
 * item or items in **Toolbar.Layout**.
 *
 * * Configure the **Toolbar.breakpoints** property to specify pixel breakpoints for
 * the `md`, `lg`, and `xl` size. If undefined,
 * the [default 16-column LayoutGrid breakpoints](https://pages.github.concur.com/coreui/nui-layouts/latest/?path=/docs/components-layoutgrid--fully-responsive-fluid#specifications)
 * will be used.
 * * Wrap item or items in the **Toolbar.Layout** component
 *  and define the responsive behavior for each breakpoint, as seen the examples below.
 * * For each breakpoint, the wrapping behavior can be
 *   * `'hide'`: hide at (or below) the breakpoint.
 *   * `'overflow'`: move to overflow menu at (or below) the breakpoint.
 *     * order of overflowing items will be dependent on the **Toolbar.Layout.overflowOrder**.
 *   * `React.node`: display a React.node at (or below) the breakpoint.
*/

var Toolbar = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context2, _context3, _context4, _classnames, _context5, _context6, _context7;
  var autoOverflow = _ref.autoOverflow,
    children = _ref.children,
    className = _ref.className,
    classNameMap = _ref.classNameMap,
    customTitle = _ref.customTitle,
    title = _ref.title,
    titleProps = _ref.titleProps,
    toolbarStyle = _ref.toolbarStyle,
    borderBottom = _ref.borderBottom,
    borderTop = _ref.borderTop,
    focusProps = _ref.focusProps,
    isFocused = _ref.isFocused,
    breakpoints = _ref.breakpoints,
    overflowButtonLabel = _ref.overflowButtonLabel,
    itemsSize = _ref.itemsSize,
    onSizeChange = _ref.onSizeChange,
    overflowContainerRef = _ref.overflowContainerRef,
    onOverflowToggle = _ref.onOverflowToggle,
    overflowButtonProps = _ref.overflowButtonProps,
    overflowItemsSize = _ref.overflowItemsSize,
    tableToolbar = _ref.tableToolbar,
    toolbarProps = _ref.toolbarProps,
    otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    currentWidth = _useState2[0],
    setCurrentWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    overflowOpen = _useState4[0],
    setOverflowOpen = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    autoOverflowingItems = _useState6[0],
    setAutoOverflowingItems = _useState6[1];
  var toolBarRef = (0, _react.useRef)();
  var overflowMenuRef = (0, _react.useRef)();
  var mergedRef = (0, _reactMergeRefs.default)([toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.ref, toolBarRef]);
  var liveRegionRef = (0, _react.useRef)(null);
  var useLiveRegion = (0, _react.useRef)(false);
  var overflowKey = (0, _useUniqueId.default)();
  var classnames = _bind.default.bind(classNameMap);
  var childrenCount = _react.default.Children.count(children);
  var startClasses = [];
  var startProps = {};
  var centerClasses = [];
  var centerProps = {};
  var endClasses = [];
  var endProps = {};
  var start = childrenCount ? (0, _map.default)(_context2 = _react.default.Children).call(_context2, children, function (c) {
    if (!c || !c.type || !c.props) {
      return null;
    }
    if (c.type.displayName === START_REGION_DISPLAY_NAME) {
      startClasses.push(c.props.className);
      startProps = c.props;
      return getChildNodes(c);
    }
    if (c.type.displayName !== CENTER_REGION_DISPLAY_NAME && c.type.displayName !== END_REGION_DISPLAY_NAME) {
      return c;
    }
    return null;
  }) : [];
  var center = childrenCount ? (0, _map.default)(_context3 = _react.default.Children).call(_context3, children, function (c) {
    var _c$type;
    if ((c === null || c === void 0 || (_c$type = c.type) === null || _c$type === void 0 ? void 0 : _c$type.displayName) === CENTER_REGION_DISPLAY_NAME) {
      centerClasses.push(c.props.className);
      centerProps = c.props;
      return getChildNodes(c);
    }
    return null;
  }) : [];
  var end = childrenCount ? (0, _map.default)(_context4 = _react.default.Children).call(_context4, children, function (c) {
    var _c$type2;
    if ((c === null || c === void 0 || (_c$type2 = c.type) === null || _c$type2 === void 0 ? void 0 : _c$type2.displayName) === END_REGION_DISPLAY_NAME) {
      endClasses.push(c.props.className);
      endProps = c.props;
      return getChildNodes(c);
    }
    return null;
  }) : [];
  var isIconOnlyButtonWithTooltip = function isIconOnlyButtonWithTooltip(componentChildren, componentName) {
    var _componentChildren$ty, _componentChildren$pr;
    return componentName === 'Tooltip' && (componentChildren === null || componentChildren === void 0 || (_componentChildren$ty = componentChildren.type) === null || _componentChildren$ty === void 0 ? void 0 : _componentChildren$ty.displayName) === 'Button' && (componentChildren === null || componentChildren === void 0 || (_componentChildren$pr = componentChildren.props) === null || _componentChildren$pr === void 0 || (_componentChildren$pr = _componentChildren$pr.children) === null || _componentChildren$pr === void 0 || (_componentChildren$pr = _componentChildren$pr.type) === null || _componentChildren$pr === void 0 ? void 0 : _componentChildren$pr.displayName) === 'Icon';
  };
  var isButtonWithIcons = function isButtonWithIcons(componentChildren, componentName) {
    var _React$Children$toArr;
    return componentName === 'Button' && ((_React$Children$toArr = _react.default.Children.toArray(componentChildren)) === null || _React$Children$toArr === void 0 ? void 0 : _React$Children$toArr.some(function (buttonChild) {
      var _buttonChild$type;
      return (buttonChild === null || buttonChild === void 0 || (_buttonChild$type = buttonChild.type) === null || _buttonChild$type === void 0 ? void 0 : _buttonChild$type.displayName) === 'Icon';
    }));
  };
  var toolbarItemsRef = (0, _react.useRef)();
  toolbarItemsRef.current = (0, _react.useMemo)(function () {
    var flatChildren = [];
    if (!autoOverflow) return flatChildren;
    var getToolbarItems = function getToolbarItems(currentChild, currentChildIdex, childArray) {
      var _currentChild$type, _currentChild$props, _currentChild$props7;
      var componentName = currentChild === null || currentChild === void 0 || (_currentChild$type = currentChild.type) === null || _currentChild$type === void 0 ? void 0 : _currentChild$type.displayName;
      var currentGrandKids = currentChild === null || currentChild === void 0 || (_currentChild$props = currentChild.props) === null || _currentChild$props === void 0 ? void 0 : _currentChild$props.children;
      if (TOOLBAR_ITEMS.indexOf(componentName) !== -1) {
        if (componentName === 'IconButton' || componentName === 'IconLink') {
          var _currentChild$props3, _currentChild$props4;
          // convert IconButton to button with text, IconLink to Link with text
          var _currentChild$props2 = currentChild === null || currentChild === void 0 ? void 0 : currentChild.props,
            ariaLabel = _currentChild$props2.ariaLabel,
            iconName = _currentChild$props2.iconName,
            tooltipDelay = _currentChild$props2.tooltipDelay,
            tooltipProps = _currentChild$props2.tooltipProps,
            iconProps = _currentChild$props2.iconProps,
            adjustedProps = (0, _objectWithoutProperties2.default)(_currentChild$props2, _excluded2);
          var transformedButton = /*#__PURE__*/_react.default.createElement(componentName === 'IconButton' ? _Button.default : _Link.default, _objectSpread(_objectSpread({}, adjustedProps), {}, {
            key: currentChild === null || currentChild === void 0 || (_currentChild$props3 = currentChild.props) === null || _currentChild$props3 === void 0 ? void 0 : _currentChild$props3.ariaLabel,
            ref: currentChild === null || currentChild === void 0 ? void 0 : currentChild.ref
          }), [currentChild === null || currentChild === void 0 || (_currentChild$props4 = currentChild.props) === null || _currentChild$props4 === void 0 ? void 0 : _currentChild$props4.ariaLabel // use ariaLabel as child text
          ]);
          flatChildren.push(transformedButton);
        } else if (isIconOnlyButtonWithTooltip(currentGrandKids, componentName)) {
          var _currentChild$props5, _currentChild$props6;
          // convert icon only tooltip button to button with text
          var _transformedButton = /*#__PURE__*/_react.default.createElement(_Button.default, _objectSpread(_objectSpread({}, currentGrandKids.props), {}, {
            key: currentChild === null || currentChild === void 0 || (_currentChild$props5 = currentChild.props) === null || _currentChild$props5 === void 0 ? void 0 : _currentChild$props5.message
          }), [currentChild === null || currentChild === void 0 || (_currentChild$props6 = currentChild.props) === null || _currentChild$props6 === void 0 ? void 0 : _currentChild$props6.message // use tooltip.message as button label
          ]);
          flatChildren.push(_transformedButton);
        } else if (isButtonWithIcons(currentGrandKids, componentName)) {
          var _React$Children$toArr2;
          var buttonChildren = currentGrandKids;
          // remove all icons
          var buttonIconIndexes = [];
          for (var i = 0; i < (buttonChildren === null || buttonChildren === void 0 ? void 0 : buttonChildren.length); i += 1) {
            var _buttonChildren$i;
            if (((_buttonChildren$i = buttonChildren[i]) === null || _buttonChildren$i === void 0 || (_buttonChildren$i = _buttonChildren$i.type) === null || _buttonChildren$i === void 0 ? void 0 : _buttonChildren$i.displayName) === 'Icon') {
              buttonIconIndexes.push(i);
            }
          }
          var _transformedButton2 = /*#__PURE__*/_react.default.createElement(_Button.default, _objectSpread(_objectSpread({}, currentChild === null || currentChild === void 0 ? void 0 : currentChild.props), {}, {
            key: currentChildIdex
          }), (0, _toConsumableArray2.default)((_React$Children$toArr2 = _react.default.Children.toArray(buttonChildren)) === null || _React$Children$toArr2 === void 0 ? void 0 : (0, _filter.default)(_React$Children$toArr2).call(_React$Children$toArr2, function (buttonChild, index) {
            return buttonIconIndexes.indexOf(index) === -1;
          })));
          flatChildren.push(_transformedButton2);
        } else {
          flatChildren.push(currentChild);
        }
      } else if (typeof (currentChild === null || currentChild === void 0 || (_currentChild$props7 = currentChild.props) === null || _currentChild$props7 === void 0 ? void 0 : _currentChild$props7.children) !== 'string') {
        var _currentChild$props8;
        _react.default.Children.forEach(currentChild === null || currentChild === void 0 || (_currentChild$props8 = currentChild.props) === null || _currentChild$props8 === void 0 ? void 0 : _currentChild$props8.children, function (grandChild, grandChildIndex) {
          getToolbarItems(grandChild, grandChildIndex, childArray);
        });
      } else {
        flatChildren.push(currentChild);
      }
    };
    _react.default.Children.forEach(children, function (mainChild) {
      getToolbarItems(mainChild, 0, flatChildren);
    });
    return flatChildren;
  }, [autoOverflow, autoOverflowingItems, children]);
  var overflowMaps = (0, _react.useMemo)(function () {
    if (autoOverflow) return {};
    var smMap = {};
    var mdMap = {};
    var lgMap = {};
    var xlMap = {};
    var mapChildLayout = function mapChildLayout(currentChild, sizeMaps) {
      var _currentChild$type2, _currentChild$type3;
      if ((currentChild === null || currentChild === void 0 || (_currentChild$type2 = currentChild.type) === null || _currentChild$type2 === void 0 ? void 0 : _currentChild$type2.displayName) === 'ToolbarLayout') {
        var _currentChild$props9 = currentChild.props,
          overflowOrder = _currentChild$props9.overflowOrder,
          _currentChild$props9$ = _currentChild$props9.children,
          grandChildren = _currentChild$props9$ === void 0 ? [] : _currentChild$props9$;
        (0, _responsiveOverflowUtils.forEachSize)(function (eachSize) {
          if (currentChild.props[eachSize] === 'overflow') {
            (0, _responsiveOverflowUtils.addOverflowItemsToSizeMap)(sizeMaps[eachSize], overflowOrder, grandChildren);
          }
        });
      } else if ([START_REGION_DISPLAY_NAME, CENTER_REGION_DISPLAY_NAME, END_REGION_DISPLAY_NAME].indexOf(currentChild === null || currentChild === void 0 || (_currentChild$type3 = currentChild.type) === null || _currentChild$type3 === void 0 ? void 0 : _currentChild$type3.displayName) !== -1) {
        _react.default.Children.forEach(currentChild.props.children, function (grandChild) {
          mapChildLayout(grandChild, sizeMaps);
        });
      }
    };
    _react.default.Children.forEach(children, function (mainChild) {
      mapChildLayout(mainChild, {
        sm: smMap,
        md: mdMap,
        lg: lgMap,
        xl: xlMap
      });
    });
    return {
      sm: smMap,
      md: mdMap,
      lg: lgMap,
      xl: xlMap
    };
  }, [autoOverflow, childrenCount]);
  var classes = classnames(CSS_BLOCK, className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--").concat(toolbarStyle), !!toolbarStyle), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--border-bottom"), !!borderBottom), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--border-top"), !!borderTop), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "__table"), !!tableToolbar), _classnames));
  (0, _react.useEffect)(function () {
    if (typeof onSizeChange === 'function') {
      onSizeChange(currentWidth);
    }
  }, [currentWidth]);
  (0, _useResponsiveSizes.default)(function (currentSize) {
    setCurrentWidth(currentSize);
  }, toolBarRef, breakpoints);
  (0, _useFocusManager.default)({
    nextKeyCode: _keycode.default.codes.right,
    previousKeyCode: _keycode.default.codes.left,
    firstFocusIndex: 0,
    suppressInitialAttachment: true,
    stopKeyPressPropagation: true
  }, !overflowOpen && isFocused, toolBarRef);
  var setNodeOverflowAttributes = function setNodeOverflowAttributes(targetNode, overflowState) {
    if (!targetNode) return;
    if (overflowState) {
      targetNode.classList.add(classnames("".concat(CSS_BLOCK, "--hidden")));
      targetNode.setAttribute('data-is-overflowing', 'true');
      if (targetNode.id) {
        targetNode.setAttribute('id', "".concat(targetNode.id, "--overflow"));
      }
    } else {
      targetNode.classList.remove(classnames("".concat(CSS_BLOCK, "--hidden")));
      targetNode.removeAttribute('data-is-overflowing');
      if (targetNode.id) {
        targetNode.setAttribute('id', "".concat(targetNode.id.replace('--overflow', '')));
      }
    }
  };
  var revertOverflow = function revertOverflow() {
    var _toolBarRef$current;
    var overflownNodes = (toolBarRef === null || toolBarRef === void 0 || (_toolBarRef$current = toolBarRef.current) === null || _toolBarRef$current === void 0 ? void 0 : _toolBarRef$current.querySelectorAll('[data-is-overflowing="true"]')) || [];
    for (var i = 0; i < overflownNodes.length; i += 1) {
      var eachOverflownItem = overflownNodes[i];
      setNodeOverflowAttributes(eachOverflownItem, false);
    }
  };
  var getOverflowingItems = function getOverflowingItems(shouldOverflow) {
    var _toolBarRef$current2, _toolbarItemsRef$curr;
    var toolbarNodes = (toolBarRef === null || toolBarRef === void 0 || (_toolBarRef$current2 = toolBarRef.current) === null || _toolBarRef$current2 === void 0 ? void 0 : _toolBarRef$current2.querySelectorAll('[data-toolbar-item="true"]')) || [];
    var overflownItemsWidth = 0;
    if (toolbarNodes !== null && toolbarNodes !== void 0 && toolbarNodes.length && (toolbarNodes === null || toolbarNodes === void 0 ? void 0 : toolbarNodes.length) === ((_toolbarItemsRef$curr = toolbarItemsRef.current) === null || _toolbarItemsRef$curr === void 0 ? void 0 : _toolbarItemsRef$curr.length)) {
      var overflownItems = [];
      for (var i = toolbarNodes.length - 1; i > -1; i -= 1) {
        var eachToolbarNode = toolbarNodes[i];
        overflownItemsWidth += (eachToolbarNode === null || eachToolbarNode === void 0 ? void 0 : eachToolbarNode.offsetWidth) || 0;
        setNodeOverflowAttributes(eachToolbarNode, true);
        overflownItems.unshift(toolbarItemsRef.current[i]);
        var enoughOverflown = overflownItemsWidth > shouldOverflow;
        if (enoughOverflown) {
          break;
        }
      }
      return overflownItems;
    }
    return [];
  };
  var handleResize = (0, _debounce.default)(function () {
    var _toolBarRef$current3, _toolBarRef$current4;
    revertOverflow();
    var toolbarWidth = (toolBarRef === null || toolBarRef === void 0 || (_toolBarRef$current3 = toolBarRef.current) === null || _toolBarRef$current3 === void 0 ? void 0 : _toolBarRef$current3.offsetWidth) || 0;
    var toolbarScroll = (toolBarRef === null || toolBarRef === void 0 || (_toolBarRef$current4 = toolBarRef.current) === null || _toolBarRef$current4 === void 0 ? void 0 : _toolBarRef$current4.scrollWidth) || 0;
    var hasScrollbar = toolbarWidth < toolbarScroll;
    if (hasScrollbar) {
      var overflowingItems = getOverflowingItems(toolbarScroll - toolbarWidth + OVERFLOW_PADDING);
      setAutoOverflowingItems(overflowingItems);
    } else {
      setAutoOverflowingItems([]);
    }
  });
  var toolBarSizeRef = (0, _react.useRef)(null);
  (0, _useResizeObserver.default)({
    disconnect: !autoOverflow,
    targetRef: toolBarSizeRef,
    onResize: handleResize
  });
  (0, _useUniversalLayoutEffect.default)(function () {
    if (autoOverflow) {
      handleResize();
    } else {
      revertOverflow();
    }
  }, [autoOverflow]);
  var handleOverflowToggle = function handleOverflowToggle(open) {
    setOverflowOpen(!!open);
    if ((0, _isFunction.default)(onOverflowToggle)) {
      onOverflowToggle(open);
    }
  };
  var renderOverflowMenu = function renderOverflowMenu(overflowItems) {
    return /*#__PURE__*/_react.default.createElement(_ToolbarOverflow.default, {
      classNameMap: classNameMap,
      cssBlock: CSS_BLOCK,
      overflowItemsSize: overflowItemsSize,
      overflowButtonProps: overflowButtonProps,
      ref: (0, _reactMergeRefs.default)([overflowMenuRef, overflowContainerRef]),
      overflowButtonLabel: overflowButtonLabel,
      onOverflowToggle: handleOverflowToggle,
      key: overflowKey
    }, overflowItems);
  };
  if (!autoOverflow && (0, _keys.default)((overflowMaps === null || overflowMaps === void 0 ? void 0 : overflowMaps[currentWidth]) || {}).length) {
    end.push(renderOverflowMenu((0, _responsiveOverflowUtils.getWidthItems)(overflowMaps, currentWidth)));
  }
  var addChildProps = function addChildProps(classnamesFn, child, childProps) {
    var _classnamesFn2;
    if (childProps['data-tooltip-target'] === true) {
      return {};
    }
    if (child.displayName === 'ButtonDropdown') {
      var _classnamesFn;
      // ButtonDropdown has much different markup so needs values passed to different props
      return {
        size: itemsSize,
        containerProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.containerProps), {}, {
          'data-toolbar-item': true
        }),
        className: classnamesFn(childProps.className, "".concat(CSS_BLOCK, "__item")),
        buttonClassName: classnamesFn(childProps.buttonClassName, (_classnamesFn = {}, (0, _defineProperty2.default)(_classnamesFn, "".concat(CSS_BLOCK, "__link"), childProps.type === 'link'), (0, _defineProperty2.default)(_classnamesFn, "".concat(CSS_BLOCK, "__compact"), (childProps === null || childProps === void 0 ? void 0 : childProps.type) === 'link' && (childProps === null || childProps === void 0 ? void 0 : childProps.compact)), _classnamesFn)),
        textLabelClassName: classnamesFn(childProps.textLabelClassName, "".concat(CSS_BLOCK, "__label"))
      };
    }
    if (child.displayName === 'ToolbarLayout') {
      var widthBehavior = (0, _responsiveOverflowUtils.getWidthBehavior)(childProps, currentWidth);
      return {
        className: classnamesFn(childProps.className, "".concat(CSS_BLOCK, "__layout")),
        hide: widthBehavior === 'hide' || widthBehavior === 'overflow',
        replaceWith: (0, _typeof2.default)(widthBehavior) === 'object' && widthBehavior
      };
    }
    if (child.displayName === 'ToolbarSeparator') {
      return {
        size: itemsSize,
        'data-toolbar-item': true
      };
    }
    if (child.displayName === 'Tooltip') {
      var _childProps$targetPro;
      return {
        targetProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.targetProps), {}, {
          'data-toolbar-item': !(childProps !== null && childProps !== void 0 && (_childProps$targetPro = childProps.targetProps) !== null && _childProps$targetPro !== void 0 && _childProps$targetPro['data-toolbar-trigger'])
        }),
        targetClassName: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.targetClassName, "".concat(CSS_BLOCK, "__item"))
      };
    }
    if (child.displayName === 'Link' || child.displayName === 'IconLink') {
      return {
        size: itemsSize,
        'data-toolbar-item': !childProps['data-toolbar-trigger'] && child.displayName !== 'IconLink',
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, "".concat(CSS_BLOCK, "__item"), "".concat(CSS_BLOCK, "__link"), "".concat(CSS_BLOCK, "__link--").concat(itemsSize || 'lg')),
        matchButtonHeight: true,
        innerTextClasses: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.innerTextClasses, "".concat(CSS_BLOCK, "__text"))
      };
    }
    if (child.displayName === 'Switch') {
      var _childProps$labelProp;
      return {
        'data-toolbar-item': !childProps['data-toolbar-trigger'],
        size: itemsSize,
        className: classnamesFn(childProps.className, "".concat(CSS_BLOCK, "__item")),
        labelProps: _objectSpread(_objectSpread({}, childProps === null || childProps === void 0 ? void 0 : childProps.labelProps), {}, {
          className: classnamesFn(childProps === null || childProps === void 0 || (_childProps$labelProp = childProps.labelProps) === null || _childProps$labelProp === void 0 ? void 0 : _childProps$labelProp.className, "".concat(CSS_BLOCK, "__label"))
        })
      };
    }
    if (child.displayName === 'RadioGroup') {
      return {
        'data-toolbar-item': !childProps['data-toolbar-trigger'],
        size: itemsSize,
        inline: true,
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, "".concat(CSS_BLOCK, "__item")),
        childRadioLabelClass: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.childRadioLabelClass, "".concat(CSS_BLOCK, "__radio"))
      };
    }
    if (child.displayName === 'Checkbox') {
      return {
        'data-toolbar-item': !childProps['data-toolbar-trigger'],
        size: itemsSize,
        inline: true,
        className: classnamesFn(childProps.className, "".concat(CSS_BLOCK, "__item"))
      };
    }
    if (child.displayName === 'FormField') {
      var _childProps$labelProp2, _childProps$helpTextP;
      useLiveRegion.current = true;
      return {
        'data-toolbar-item': !childProps['data-toolbar-trigger'],
        validationOverlayProps: _objectSpread(_objectSpread({}, childProps.validationOverlayProps), {}, {
          customLiveRegionRef: liveRegionRef
        }),
        labelProps: _objectSpread(_objectSpread({}, childProps.labelProps), {}, {
          className: classnamesFn(childProps === null || childProps === void 0 || (_childProps$labelProp2 = childProps.labelProps) === null || _childProps$labelProp2 === void 0 ? void 0 : _childProps$labelProp2.className, "".concat(CSS_BLOCK, "__label"))
        }),
        helpTextProps: _objectSpread(_objectSpread({}, childProps.helpTextProps), {}, {
          className: classnamesFn(childProps === null || childProps === void 0 || (_childProps$helpTextP = childProps.helpTextProps) === null || _childProps$helpTextP === void 0 ? void 0 : _childProps$helpTextP.className, "".concat(CSS_BLOCK, "__text"))
        })
      };
    }
    if (child.displayName === 'Icon') {
      return {
        size: (childProps === null || childProps === void 0 ? void 0 : childProps.size) || itemsSize
      };
    }
    if (child.displayName === 'SplitButton') {
      return {
        size: itemsSize,
        'data-toolbar-item': !childProps['data-toolbar-trigger'],
        className: classnamesFn(childProps.className, "".concat(CSS_BLOCK, "__item"))
      };
    }
    return {
      size: itemsSize,
      'data-toolbar-item': !childProps['data-toolbar-trigger'] && !childProps['data-toolbar-group-part'],
      type: tableToolbar && child.displayName === 'Button' && (childProps === null || childProps === void 0 ? void 0 : childProps.type) === 'primary' ? 'link' : childProps === null || childProps === void 0 ? void 0 : childProps.type,
      className: classnamesFn(childProps.className, "".concat(CSS_BLOCK, "__item"), (_classnamesFn2 = {}, (0, _defineProperty2.default)(_classnamesFn2, "".concat(CSS_BLOCK, "__link"), child.displayName === 'Button' && childProps.type === 'link' || tableToolbar && child.displayName === 'Button' && (childProps === null || childProps === void 0 ? void 0 : childProps.type) === 'primary'), (0, _defineProperty2.default)(_classnamesFn2, "".concat(CSS_BLOCK, "__compact"), child.displayName === 'Button' && childProps.type === 'link' && (childProps === null || childProps === void 0 ? void 0 : childProps.compact)), _classnamesFn2))
    };
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, focusProps, otherProps, {
    className: classes,
    ref: (0, _reactMergeRefs.default)([ref, toolBarSizeRef])
  }), (typeof title === 'string' ? (0, _trim.default)(title).call(title) : title) && (customTitle ? title : /*#__PURE__*/_react.default.createElement(_Title.default, (0, _extends2.default)({
    headingLevel: 4
  }, titleProps, {
    className: classnames("".concat(CSS_BLOCK, "__title"), titleProps === null || titleProps === void 0 ? void 0 : titleProps.className)
  }), title)), (childrenCount > 0 || autoOverflow && (autoOverflowingItems === null || autoOverflowingItems === void 0 ? void 0 : autoOverflowingItems.length) > 0) && /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.default.Provider, {
    value: addChildProps.bind(null, classnames)
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, toolbarProps, {
    className: classnames("".concat(CSS_BLOCK, "__toolbar"), toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.className),
    role: "toolbar",
    ref: mergedRef
  }), start.length > 0 && /*#__PURE__*/_react.default.createElement(Toolbar.Start, (0, _extends2.default)({}, startProps, {
    className: classnames.apply(void 0, (0, _concat.default)(_context5 = ["".concat(CSS_BLOCK, "__start")]).call(_context5, startClasses))
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.default.Provider, {
    value: addChildProps.bind(null, classnames)
  }, start)), center.length > 0 && /*#__PURE__*/_react.default.createElement(Toolbar.Center, (0, _extends2.default)({}, centerProps, {
    className: classnames.apply(void 0, (0, _concat.default)(_context6 = ["".concat(CSS_BLOCK, "__center")]).call(_context6, centerClasses))
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.default.Provider, {
    value: addChildProps.bind(null, classnames)
  }, center)), end.length > 0 && /*#__PURE__*/_react.default.createElement(Toolbar.End, (0, _extends2.default)({}, endProps, {
    className: classnames.apply(void 0, (0, _concat.default)(_context7 = ["".concat(CSS_BLOCK, "__end")]).call(_context7, endClasses))
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.default.Provider, {
    value: addChildProps.bind(null, classnames)
  }, end)), autoOverflow && autoOverflowingItems !== null && autoOverflowingItems !== void 0 && autoOverflowingItems.length ? renderOverflowMenu(autoOverflowingItems) : null)), useLiveRegion.current && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__live-region")),
    "data-test": "toolbar-status",
    "aria-live": "polite",
    role: "status",
    ref: liveRegionRef
  }));
});
Toolbar.displayName = DISPLAY_NAME;
Toolbar.propTypes = {
  /** @ignore set by TableToolbar */
  tableToolbar: _propTypes.default.bool,
  /** Collection of React components to be placed in the region. */
  children: _propTypes.default.node,
  /** Custom classes to add to the **Toolbar** enclosing `<div>` tag. */
  className: _propTypes.default.string,
  /** A localized string or a React node to use as title (<Title /> component) for the toolbar. */
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /** Additional props to spread to the toolbar <Title />. */
  titleProps: _propTypes.default.object,
  /** Set to **true** if you're using a highly custom
   * `Toolbar.title` that is not compatible with the
   * <Title /> component to avoid accessibility
   * pitfalls (invalid nesting).
   */
  customTitle: _propTypes.default.bool,
  /** Visual style of the toolbar:
   *
   * * `solid`: will have a solid background (only in Gateway).
   * * `transparent`: no background.
   */
  toolbarStyle: _propTypes.default.oneOf(_StyleConfig.TOOLBAR_STYLES),
  /** Set to true to show a border-bottom for the toolbar. */
  borderBottom: _propTypes.default.bool,
  /** Set to true to show a border-top for the toolbar. */
  borderTop: _propTypes.default.bool,
  /** Set to true to automatically add overflowing items to a popover menu which will be added
   * at the end of the toolbar when it overflows. To fine-tune overflow behavior at
   * various breakpoints use the Toolbar.Layout component instead.
   * Do not use a mixture of both these methods.
   *
   * By default, the overflow **IconButton** will appear at the end of the **Toolbar**.
   */
  autoOverflow: _propTypes.default.bool,
  /** Size breakpoints in pixels.
   * See standard 16 column LayoutGrid breakpoints
   *  [here](https://pages.github.concur.com/coreui/nui-layouts/latest/?path=/docs/components-layoutgrid--fully-responsive-fluid#specifications).
   * Sizes less than 'md' will be considered 'sm'.
   */
  breakpoints: _propTypes.default.shape({
    md: _propTypes.default.number.isRequired,
    lg: _propTypes.default.number.isRequired,
    xl: _propTypes.default.number.isRequired
  }),
  /** Size of Toolbar items. */
  itemsSize: _propTypes.default.oneOf(_StyleConfig.CONTROL_SIZES),
  /** Localized string aria-label for toolbar overflow menu trigger button.
   * Don't forget to set this if using overflow behavior at any breakpoint.
   */
  overflowButtonLabel: _propTypes.default.string,
  /** Additional props to spread to the overflow trigger button. */
  overflowButtonProps: _propTypes.default.object,
  /** Attach a ref to the `<div>` wrapper containing overflow items. */
  overflowContainerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** Size of overflowing items in the overflow menu. */
  overflowItemsSize: _propTypes.default.oneOf(_StyleConfig.CONTROL_SIZES),
  /** Additional props to spread `<div role="toolbar">` element. */
  toolbarProps: _propTypes.default.object,
  /** @ignore, comes from  withFocusWithin HOC. */
  isFocused: _propTypes.default.bool,
  /** @ignore, comes from  withFocusWithin HOC. */
  focusProps: _propTypes.default.any,
  /** Callback function for when toolbar size crosses
   *  any size breakpoints defined in breakpoints. */
  onSizeChange: _propTypes.default.func,
  /** Callback function for when toolbar overflow menu popover
   *  is opened or closed.
   *
   * @param {Boolean} open - indicating if overflow menu is opened.  */
  onOverflowToggle: _propTypes.default.func
};
Toolbar.defaultProps = {
  breakpoints: {
    md: 600,
    lg: 1024,
    xl: 1440
  },
  itemsSize: 'lg',
  overflowItemsSize: 'lg',
  toolbarStyle: 'solid'
};
Toolbar.Start = (0, _ToolbarRegion.default)(START_REGION_DISPLAY_NAME);
Toolbar.Center = (0, _ToolbarRegion.default)(CENTER_REGION_DISPLAY_NAME);
Toolbar.End = (0, _ToolbarRegion.default)(END_REGION_DISPLAY_NAME);
Toolbar.Layout = _ToolbarLayout.default;
Toolbar.Separator = _ToolbarSeparator.default;
var _default = (0, _withFocusWithin.default)((0, _reactUiTheming.withThemeStyles)(styles)(Toolbar));
exports.default = _default;